/* tslint:disable */
/* eslint-disable */
/**
 * My Title
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UndercarriageReportPhotoResponse
 */
export interface UndercarriageReportPhotoResponse {
    /**
     * 
     * @type {string}
     * @memberof UndercarriageReportPhotoResponse
     */
    section?: string;
    /**
     * 
     * @type {string}
     * @memberof UndercarriageReportPhotoResponse
     */
    location?: string;
    /**
     * 
     * @type {string}
     * @memberof UndercarriageReportPhotoResponse
     */
    caption?: string;
    /**
     * 
     * @type {string}
     * @memberof UndercarriageReportPhotoResponse
     */
    comment?: string;
    /**
     * 
     * @type {number}
     * @memberof UndercarriageReportPhotoResponse
     */
    observationId?: number;
    /**
     * 
     * @type {number}
     * @memberof UndercarriageReportPhotoResponse
     */
    fileId?: number;
}

/**
 * Check if a given object implements the UndercarriageReportPhotoResponse interface.
 */
export function instanceOfUndercarriageReportPhotoResponse(value: object): value is UndercarriageReportPhotoResponse {
    return true;
}

export function UndercarriageReportPhotoResponseFromJSON(json: any): UndercarriageReportPhotoResponse {
    return UndercarriageReportPhotoResponseFromJSONTyped(json, false);
}

export function UndercarriageReportPhotoResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UndercarriageReportPhotoResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'section': json['section'] == null ? undefined : json['section'],
        'location': json['location'] == null ? undefined : json['location'],
        'caption': json['caption'] == null ? undefined : json['caption'],
        'comment': json['comment'] == null ? undefined : json['comment'],
        'observationId': json['observationId'] == null ? undefined : json['observationId'],
        'fileId': json['fileId'] == null ? undefined : json['fileId'],
    };
}

export function UndercarriageReportPhotoResponseToJSON(json: any): UndercarriageReportPhotoResponse {
    return UndercarriageReportPhotoResponseToJSONTyped(json, false);
}

export function UndercarriageReportPhotoResponseToJSONTyped(value?: UndercarriageReportPhotoResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'section': value['section'],
        'location': value['location'],
        'caption': value['caption'],
        'comment': value['comment'],
        'observationId': value['observationId'],
        'fileId': value['fileId'],
    };
}

